export const candidateSelector = (state) => state.newJob.candidate.data;
export const isLoadingCandidateSelector = (state) =>
  state.newJob.candidate.isLoading;

export const isLoadingCandidatePDFReportSelector = (state) =>
  state.newJob.candidate.isLoadingPDFReport;

export const isLoadingUpdateSelector = (state) =>
  state.newJob.candidate.isLoadingUpdate;
